<template>

<div v-cloak>

  <div class="card card--large">
    <div class="card__inner">

      <h2>{{ $_('scheduled_reports') }}</h2>

      <table class="table table--striped table--word-break table--stackable milli flush--bottom" v-show="reports.length">
        <thead>
        <tr>
          <th>{{ $_('to') }}, {{ $_('cc') }}, {{ $_('bcc') }}</th>
          <!-- <th></th> -->
          <th>{{ $_('frequency') }}</th>
          <th>{{ $_('start_date') }}</th>
          <th>{{ $_('language') }}</th>
          <th>{{ $_('actions') }}</th>
        </tr>
        </thead>
        <tbody>
          <tr v-for="item in reports" v-bind:key="item.id" valign="top">
            <td :data-title="$_('to')">
              <div class="truncate" v-bind:title="item.to" style="width: 300px;">{{ item.to }}</div>
              <div class="truncate" v-bind:title="item.cc" style="width: 300px;">{{ item.cc }}</div>
              <div class="truncate" v-bind:title="item.bcc" style="width: 300px;">{{ item.bcc }}</div>
            </td>
            <!-- <td><span class="fa fa-file-text-o" v-show="item.attachment" :title="$_('report_include_attachment')"></span></td> -->
            <td :data-title="$_('frequency')">{{ getFrequencyName(item.frequency) }}</td>
            <td :data-title="$_('start_date')" v-bind:title="item.start_date">{{ item.start_date }}</td>
            <td :data-title="$_('language')" v-bind:title="item.lang">{{ getLangName(item.lang) }}</td>
            <td :data-title="$_('actions')">
              <div class="button-group flush--bottom">
                <button class="button button--small" v-bind:class="{ 'button--green': !item.active }" @click="toggle(item)">{{ (item.active) ? $_('disable') : $_('enable') }}</button>
                <button class="button button--small button--light" @click="edit(item)">{{ $_('edit') }}</button>
                <button class="button button--small button--light" @click="remove(item)">{{ $_('delete') }}</button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <p v-show="!reports.length">{{ $_('no_reports') }}</p>

      <button type="button" class="button button--primary push--top" v-on:click="enableNew" v-show="!showNew">{{ $_('add_new') }}</button>

    </div>
  </div>

  <div class="card card--large js-report-form" v-show="showNew">
    <div class="card__inner">

      <form v-on:submit.prevent="onSubmit('form')" data-vv-scope="form">
        <h2>{{ (report.id) ? `${$_('edit_report')} ${report.id}` : $_('create_a_new_schedule') }}</h2>
        <p v-show="!report.id">{{ $_('create_a_new_schedule_description') }}</p>
        <div class="form grid">
          <div class="grid__item one-third portable--one-whole">
            <div class="form__line">
              <div class="form__field">
                <label for="to">{{ $_('to') }}:</label>
                <input type="text" v-validate="'required'" name="to" id="to" v-model="report.to" class="field field--text" :class="{ 'parsley-error': errors.has('report.to') }">
                <span v-show="errors.has('report.to')" class="parsley-errors-list ">{{ errors.first('report.to') }}</span>
              </div>
            </div>
            <div class="form__line">
              <div class="form__field">
                <label for="cc">{{ $_('cc') }}:</label>
                <input type="text" name="cc" id="cc" v-model="report.cc" class="field field--text" :class="{ 'parsley-error': errors.has('report.cc') }">
                <span v-show="errors.has('report.cc')" class="parsley-errors-list ">{{ errors.first('report.cc') }}</span>
              </div>
            </div>
            <div class="form__line">
              <div class="form__field">
                <label for="bcc">{{ $_('bcc') }}:</label>
                <input type="text" name="bcc" id="bcc" v-model="report.bcc" class="field field--text" :class="{ 'parsley-error': errors.has('report.bcc') }">
                <span v-show="errors.has('report.bcc')" class="parsley-errors-list ">{{ errors.first('report.bcc') }}</span>
              </div>
            </div>
            <!-- <div class="form__line">
              <div class="form__field">
                <label for="attachment">
                  <input type="checkbox" id="attachment" name="attachment" v-model="report.attachment"> {{ $_('report_include_attachment') }}
                </label>
              </div>
            </div> -->
          </div><div class="grid__item one-third portable--one-whole">
            <div class="form__line">
              <div class="form__field">
                <label for="frequency">{{ $_('frequency') }}:</label>
                <select v-validate="'required'" name="frequency" id="frequency" v-model.number="report.frequency" class="field field--select">
                  <option value="1">{{ getFrequencyName(1) }}</option>
                  <option value="7">{{ getFrequencyName(7) }}</option>
                  <option value="14">{{ getFrequencyName(14) }}</option>
                  <option value="30">{{ getFrequencyName(30) }}</option>
                </select>
              </div>
            </div>
            <div class="form__line">
              <div class="form__field">
                <label for="start_date">{{ $_('start_date') }}:</label>
                <input type="date" v-validate="'required'" name="start_date" class="field field--text" v-model="report.start_date" />
              </div>
            </div>
            <div class="form__line">
              <div class="form__field">
                <label for="lang">{{ $_('language') }}:</label>
                <select v-validate="'required'" name="lang" class="field field--select" v-model="report.lang">
                  <option value="en">{{ $_('english') }}</option>
                  <option value="fr">{{ $_('french') }}</option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div class="form__line">
          <div class="form__field">
            <label for="run_now">
              <input type="checkbox" id="run_now" name="run_now" v-model="report.run_now"> {{ $_('run_now') }}
            </label>
          </div>
        </div>
        <div class="form__line flush--bottom">
          <button type="submit" class="button button--primary">{{ (report.id) ? $_('update_schedule') : $_('create_schedule') }}</button>
          <button type="button" class="button button--default" @click="disableNew">{{ $_('cancel') }}</button>
        </div>
      </form>
      <div class="form__line push--top flush--bottom" v-show="error">
        <div class="form__field">
          <div class="parsley-error">{{ error }}</div>
        </div>
      </div>

    </div>
  </div>

</div>

</template>

<script>

var urlParser = document.createElement('a');
urlParser.href = location.href;
var now = new Date();
var start_date = new Date(now.getFullYear(), now.getMonth() + 1, 1).toISOString().substr(0, 10);

var default_report = {
  to: '',
  cc: '',
  bcc: '',
  frequency: '30',
  start_date: start_date,
  lang: locale,
  attachment: false,
  active: true,
  run_now: false,
};

export default {
  name: 'reports',
  data () {
    return {
      reports: [],
      error: null,
      client: {
        id: parseInt(urlParser.pathname.split('/')[2], 10)
      },
      showNew: false,
      locale: locale,
      report: Object.assign({}, default_report)
    }
  },
  mounted () {
    this.getReports();
  },
  methods: {
    getReports: function() {
      var self = this;
      this.$http.get("/api/v1/" + this.client.id + "/reports").then(
        function(response) {
          self.reports = response.data.reports;
          self.client = response.data.client;
        },
        function(error) {
          console.error(error);
        }
      )
    },
    enableNew: function() {
      this.showNew = true;
      const el = this.$el.getElementsByClassName('js-report-form')[0];
      if (el) {
        el.scrollIntoView();
      }
    },
    disableNew: function() {
      this.showNew = false;
      this.clearNew();
    },
    getFrequencyName: function(freq) {
      switch (freq) {
        case 1:
          return this.$_('daily');
          break;
        case 7:
          return this.$_('weekly');
          break;
        case 14:
          return this.$_('biweekly');
          break;
        case 30:
          return this.$_('monthly');
          break;

        default:
          return freq;
          break;
      }
    },
    getLangName: function(lang) {
      switch (lang) {
        case 'fr':
          return this.$_('french');
          break;

        default:
          return this.$_('english');
          break;
      }
    },
    clearNew: function() {
      this.report = Object.assign({}, default_report);
      this.error = null;
    },
    onSubmit: function(scope) {
      var self = this;
      self.$validator.validateAll(scope).then(function(result) {
        if (!result) {
          return false;
        }
        var data = {
          id: self.report.id ? self.report.id : null,

          to: self.report.to,
          cc: self.report.cc,
          bcc: self.report.bcc,

          frequency: parseInt(self.report.frequency, 10),
          start_date: self.report.start_date,
          lang: self.report.lang,
          attachment: self.report.attachment,
          run_now: !!self.report.run_now,
        };
        if (data.id) {
          self.update(data)
        } else {
          self.post(data);
        }
      });
    },
    post: function(data) {
      var self = this;
      self.$http.post('/api/v1/' + this.client.id + '/reports', data).then(
        function(response) {
          if (response.data.status) {
            self.getReports();
            self.clearNew();
            self.disableNew();
          }
        },
        function(error) {
          console.error(error);
          self.error = error.response.data;
        }
      );
    },
    update: function(data) {
      var self = this;
      self.$http.put('/api/v1/' + this.client.id + '/reports/' + data.id, data).then(
        function(response) {
          if (response.data.status) {
            self.getReports();
            self.clearNew();
            self.disableNew();
          }
        },
        function(error) {
          console.error(error);
          self.error = error.response.data;
        }
      );
    },
    edit: function(report) {
      this.report = JSON.parse(JSON.stringify(report));
      this.error = null;
      this.enableNew();
    },
    remove: function(report) {
      if (!confirm(this.$_('schedule_confirm'))) { return false; }
      var self = this;
      self.$http.delete('/api/v1/' + this.client.id + '/reports/' + report.id).then(
        function(response) {
          if (response.data.status) {
            self.getReports();
          }
        },
        function(error) {
          console.error(error);
          self.error = error.response.data;
        }
      )
    },
    toggle: function(report) {
      report.active = !report.active;
      this.update(report);
    }
  }
}

</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/Reports.vue